import React from "react";
import { createRoot } from "react-dom/client";
import { Auth0Provider } from "@auth0/auth0-react";
import { config } from "./config";
import { LazyLoadingFallback } from "./components/LazyLoadingFallback";

const scopes = [
  "activate:pipeline",
  "activate:connection",
  "read:account",
  "read:billing",
  "read:connection",
  "read:pipeline",
  "read:stream",
  "write:account",
  "write:billing",
  "write:connection",
  "write:pipeline",
  "write:stream",
  "write:preview",
  "profile",
  "email",
  "openid",
];

export function bootstrap(AppPromise) {
  const App = React.lazy(() => AppPromise);

  const root = createRoot(document.getElementById("app"));

  root.render(
    <Auth0Provider
      domain={config.DECODABLE_AUTH0_DOMAIN}
      clientId={config.DECODABLE_AUTH0_SPA_CLIENT_ID}
      authorizationParams={{
        audience: config.DECODABLE_AUTH0_API_AUDIENCE,
        redirect_uri: `${window.location.origin}/-/callback/auth`,
        scope: scopes.join(" "),
      }}
      onRedirectCallback={(appState) => {
        window.location.replace(appState.target || appState.returnTo);
      }}
      useRefreshTokens={true}
      useRefreshTokensFallback={true}
    >
      <React.Suspense fallback={<LazyLoadingFallback />}>
        <App />
      </React.Suspense>
    </Auth0Provider>
  );
}
